import React, { useContext } from 'react';
import Select from '../../@base/Select';
import SelectOption from '../../@base/SelectOption';
import ContextWatson from '../../../context/WatsonContext';
import { getFullPathFolder } from './Commons';
import styles from './DialogNode.module.css';

/**
 * Controle do item (pasta, depois de) de localização do nó
 *
 */
const DialogLocalizationItem = (props) => {
  const context = useContext(ContextWatson);

  let options = null;
  let label = '';
  let selectedId = '';
  let currentValue = '';
  const { selectedDialog } = props;
  const dialogs = { ...context.dialogs };
  const dialogsList = Object.values(dialogs);

  if (selectedDialog.id === props.selectedPreviousSibling) return null;

  if (props.item === 'pasta') {
    /** Se o item for pasta */
    label = 'Pasta';

    /** primeira opção é a instancia do watson */
    options = [{
      id: 'root',
      title: props.watsonNameInstance,
    }];

    const getPathFolder = (folder) => getFullPathFolder(folder, props.watsonNameInstance, dialogs);

    const isNotDescendant = (child, descedant) => {
      if (!dialogs[child].parent) return true;
      if (dialogs[child].parent === descedant) return false;
      return isNotDescendant(dialogs[child].parent, descedant);
    };

    /** adiciona nas opções toda arvore de pastas */
    options = options.concat(
      dialogsList
        .filter((e) => e.type === 'folder' && e.id !== selectedDialog.id && isNotDescendant(e.id, selectedDialog.id))
        .map((e) => ({ ...e, title: getPathFolder(e) })),
    );

    /** define como valor corrente a pasta pai selecionada,  */
    selectedId = props.selectedParent || 'root';
    currentValue = selectedId !== 'root' ? getPathFolder(dialogs[selectedId]) : props.watsonNameInstance;
  } else {
    /** Se o item for depois de */
    label = 'Depois de';

    /** adiciona nas opções, todos os filhos da mesma pasta pai */
    options = dialogsList
      .filter((e) => (e.parent === props.selectedParent && e.id !== selectedDialog.id));

    /** define como valor corrente o irmão anterior selecionado,
     *  se o irmão não tiver titulo, o titulo pode ser o untitlePlaceholder */
    selectedId = props.selectedPreviousSibling;
    if (selectedId) {
      currentValue = (dialogs[selectedId].title || dialogs[selectedId].untitlePlaceholder);
    }
  }

  /** Manipula a mudança dos items de localização do nó   */
  const onChangeHandler = (e) => {
    if (currentValue !== e) {
      const relatedNode = options.find((o) => (o.title === e || o.untitlePlaceholder === e));
      props.localizationItemChangeHandler(
        props.item, relatedNode,
      );
    }
  };

  /** Gera a lista opções. Se o nó não tiver titulo, o valor é untitlePlaceholder */
  const optionsList = options.map(
    (i) => {
      const value = i.title || i.untitlePlaceholder;
      return (
        <SelectOption key={i.id} selected={i.id === selectedId} title={value}>
          {value}
        </SelectOption>
      );
    },
  );

  return (
    <div className="item-list mb-3">
      <div>
        <Select
          inline
          small
          labelWidth={80}
          label={label}
          placeholder="Selecione"
          classes={styles.IntentSelect}
          value={currentValue}
          onChange={onChangeHandler}
          disabled={props.disabled}
        >
          {optionsList}
        </Select>
      </div>
    </div>
  );
};

export default DialogLocalizationItem;
